import { Component, Input, OnInit } from '@angular/core';
import { DynamicOptionsComponent } from '../dynamic-options';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { BrandingService } from '../../../../../../data-services/whitelabel.service';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

function connectionsValidator(control: AbstractControl): { [key: string]: any } {
  return Array.isArray(control.value) && control.value.length > 0 ? null : { error: false };
}

@Component({
  selector: 'automata-connections-options',
  templateUrl: './connections-options.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class ConnectionsOptionsComponent implements OnInit, DynamicOptionsComponent {
  connectionsFormControl: FormControl = new FormControl('', connectionsValidator);
  connectionsOptions: SelectInputOptionInterface[];

  @Input() initialValue: string[];
  selectedValue$ = this.connectionsFormControl.valueChanges;

  constructor(
    private readonly translateService: TranslateService,
    private readonly brandingService: BrandingService,
  ) {}

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.connectionsFormControl];
  }

  ngOnInit(): void {
    if (Array.isArray(this.initialValue)) {
      this.connectionsFormControl.setValue(this.initialValue);
    }

    this.connectionsOptions = [
      {
        label: this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.FACEBOOK'),
        value: 'facebook',
      },
      {
        label: this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.GOOGLE_MY_BUSINESS'),
        value: 'google_my_business',
      },
    ];

    this.connectionsOptions.forEach((option) => {
      option.selected = option.value === this.connectionsFormControl.value;
    });
  }

  getSelectedValue(): string {
    return this.connectionsFormControl?.value;
  }

  isFormValid(): boolean {
    return this.connectionsFormControl.valid;
  }
}
